<template>
  <b-form-group
    label="İlk Temas"
    label-for="id_meets"
  >
    <validation-provider
      #default="{ errors }"
      name="İlk Temas"
      rules="required"
    >
      <v-select
        id="id_meets"
        v-model="dataItem.id_meets"
        :options="meets"
        label="title"
        :reduce="meet => meet.id"
        placeholder="Seçiniz"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'Meet',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['suppliers/dataItem']
    },
    meets() {
      return this.$store.getters['meets/dataList']
    },
  },
  created() {
    this.getMeets()
    localize('tr')
  },
  methods: {
    getMeets() {
      this.$store.dispatch('meets/getDataList', {
        select: [
          'meets.id AS id',
          'meets.title AS title',
        ],
      })
    },
  },
}
</script>
